import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function Close({ width = 18, height = 18, fill = '#4C5053', ...props }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99989 9.79032L5.19514 13.5953C5.09126 13.699 4.9607 13.7521 4.80345 13.7546C4.64632 13.757 4.51339 13.7039 4.40464 13.5953C4.29601 13.4865 4.2417 13.3548 4.2417 13.2C4.2417 13.0453 4.29601 12.9135 4.40464 12.8048L8.20957 9.00001L4.40464 5.19526C4.30089 5.09138 4.24776 4.96082 4.24526 4.80357C4.24289 4.64645 4.29601 4.51351 4.40464 4.40476C4.51339 4.29613 4.64514 4.24182 4.79989 4.24182C4.95464 4.24182 5.08639 4.29613 5.19514 4.40476L8.99989 8.2097L12.8046 4.40476C12.9085 4.30101 13.0391 4.24788 13.1963 4.24538C13.3534 4.24301 13.4864 4.29613 13.5951 4.40476C13.7038 4.51351 13.7581 4.64526 13.7581 4.80001C13.7581 4.95476 13.7038 5.08651 13.5951 5.19526L9.7902 9.00001L13.5951 12.8048C13.6989 12.9086 13.752 13.0392 13.7545 13.1964C13.7569 13.3536 13.7038 13.4865 13.5951 13.5953C13.4864 13.7039 13.3546 13.7582 13.1999 13.7582C13.0451 13.7582 12.9134 13.7039 12.8046 13.5953L8.99989 9.79032Z"
        fill={fill}
      />
    </Svg>
  );
}
